import { SignInType } from '../schema/SignInType';

let wasTokenRefreshedInBackground = false;

/**
 * Tracks if there was token refresh in the background via a claims challenge
 * @param value
 */
export const setWasTokenRefreshedInBackground = (value: boolean) => {
    wasTokenRefreshedInBackground = value;
};

/**
 * Returns the type of sign-in that was used.
 * Applies to native app scenarios where we acquire token on the host layer and
 * sent to mini-owa.
 */
export const getSignInType = (isInteractiveSignIn: boolean): SignInType => {
    if (isInteractiveSignIn) {
        return SignInType.interactive;
    }

    if (wasTokenRefreshedInBackground) {
        return SignInType.refresh;
    }

    return SignInType.silent;
};
